import { useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../../services/api.service';

const formatError = (error) => {
  const validationErrors = error?.response?.data?.validation_errors;

  return validationErrors?.length
    ? `${error.response.data.message} ${validationErrors.join(' ')}`
    : error?.response?.data?.message || error?.message;
};

export default function useSaveClient() {
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Crée le client (clientId absent) ou met à jour sa fiche. Chaque
   * modification est tracée côté API dans l'historique du client.
   * @param {number|null} clientId - Identifiant du client existant
   * @param {object} payload - Données, features_v2 et tarification
   * @returns {Promise<object|null>} Le client enregistré, ou null en cas d'erreur
   */
  const saveClient = async (clientId, payload) => {
    try {
      setIsLoading(true);

      const response = clientId
        ? await fleetApi.put(`/super-admin/clients/${clientId}`, payload)
        : await fleetApi.post('/super-admin/clients', payload);

      if (response.status !== 200) {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }

      if (!clientId) {
        toast.success(
          `Client « ${response.data.client.name} » créé (ID ${response.data.client.client_id}).`
        );
      } else if (response.data.is_modified) {
        toast.success('Client mis à jour.');
      }

      return response.data.client;
    } catch (error) {
      toast.error(formatError(error));
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    saveClient,
  };
}
